import {
  GridAutosizeColumnsOptionsMenuItem,
  GridHeaderFiltersOptionsMenuItem,
  GridOptionsDisplayOptions,
  GridResetStateOptionsMenuItem
} from "@components/DataGrid/components/toolbar/GridToolbarOptionsButtonMenu";
import { GridAutosizeColumnsOptions } from "@components/DataGrid/models/gridAutosizeColumns";
import { GridHeaderFiltersOptions } from "@components/DataGrid/models/gridHeaderFilters";
import { GridResetStateOptions } from "@components/DataGrid/models/gridResetState";
import { useGridLogger } from "@mui/x-data-grid-premium";
import { GridPrivateApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { GridPipeProcessor, useGridRegisterPipeProcessor } from "@mui/x-data-grid/internals";
import { MutableRefObject, useCallback } from "react";

export const useGridOptions = (apiRef: MutableRefObject<GridPrivateApiPremium>): void => {
  const logger = useGridLogger(apiRef, "useGridOptions");

  /**
   * PRE-PROCESSING
   */
  const addOptionsMenuButtons = useCallback<GridPipeProcessor<"optionsMenu">>(
    (
      initialValue,
      options: { 
        autosizeColumnsOptions: GridAutosizeColumnsOptions & GridOptionsDisplayOptions; 
        headerFiltersOptions: GridHeaderFiltersOptions & GridOptionsDisplayOptions 
        resetGridStateOptions: GridResetStateOptions & GridOptionsDisplayOptions
      },
    ) => {
      if (options.autosizeColumnsOptions?.disableToolbarButton && 
          options.headerFiltersOptions?.disableToolbarButton && 
          options.resetGridStateOptions?.disableToolbarButton) {
        return initialValue;
      }
      const newValue = [...initialValue];

      if (!options.autosizeColumnsOptions?.disableToolbarButton) {
        newValue.push({
          component: <GridAutosizeColumnsOptionsMenuItem options={options.autosizeColumnsOptions} />,
          componentName: "autosizeColumnsOptions",
        });
      }
      if (!options.headerFiltersOptions?.disableToolbarButton) {
        newValue.push({
          component: <GridHeaderFiltersOptionsMenuItem options={options.headerFiltersOptions} />,
          componentName: "headerFiltersOptions",
        });
      }
       if (!options.resetGridStateOptions?.disableToolbarButton) {
        newValue.push({
          component: <GridResetStateOptionsMenuItem options={options.resetGridStateOptions} />,
          componentName: "resetGridStateOptions",
        });
      }
      return newValue;
    },
    [],
  );

  useGridRegisterPipeProcessor(apiRef, "optionsMenu", addOptionsMenuButtons);
};
